import React from 'react';
import { PageHero } from '../components/PageHero';
import { Pricing } from '../components/Pricing';
import { Competitive } from '../components/Competitive';
import { FAQ } from '../components/FAQ';
import { SectionStage } from '../components/SectionStage';
export function PricingPage() {
  return <>
      <PageHero eyebrow="Pricing" title="Pay for what" titleMuted="you validate." description="Periscan is priced like modern SaaS — based on validation scope, not procurement theater. No forced enterprise bundle. No opaque services-first slab." bg="none" data-id="element-1778" />
      <SectionStage fx="beams" data-id="element-1779">
        <Pricing data-id="element-1780" />
      </SectionStage>
      <SectionStage fx="lightning" data-id="element-1781">
        <Competitive data-id="element-1782" />
      </SectionStage>
      <SectionStage fx="squares" data-id="element-1783">
        <FAQ data-id="element-1784" />
      </SectionStage>
    </>;
}